// import { useEffect, useState } from 'react'
import { useSession } from 'next-auth/react'
import { useSearchParams } from 'next/navigation'
import { Tabs } from '@base-ui-components/react/tabs'
// import { Select } from '@base-ui-components/react/select'
// import { Toolbar } from '@base-ui-components/react/toolbar'
// import { CheckIcon, ChevronsUpDownIcon } from 'lucide-react'

import type { ProjectWithRelations } from '@/lib/project/types'
// import type { ThreadWithRelations } from '@/lib/thread/types'
// import { getThreadById } from '@/lib/thread/server'
import Animate from '../Animate'

const Projects = () => {
  const { data: session } = useSession()
  const query = useSearchParams()
  // const threadId = query.get('threadId')
  // const [thread, setThread] = useState<ThreadWithRelations | null>(null)

  const projectName = query.get('projectName')
  const project = projectName
    ? session?.user.projects.find(p => p.name === projectName)
    : null

  // const humanMessages = thread?.checkpoints
  //   .map((c: any) => c.metadata?.writes?.__start__?.messages ?? [])
  //   .flat()
  //   .filter(m => m?.id?.includes?.('HumanMessage'))
  // const dedupedHumanMessages = [...new Set(humanMessages)]

  // const aiMessages = thread?.checkpoints
  //   .map((c: any) => c.metadata?.writes?.agent?.messages ?? [])
  //   .flat()
  // const dedupedAiMessages = [...new Set(aiMessages)]

  // useEffect(() => {
  //   if (threadId != null && session?.user != null) {
  //     const initThread = async () => {
  //       setThread((await getThreadById(threadId)) as ThreadWithRelations)
  //     }
  //     initThread()
  //   }
  //   return () => setThread(null)
  // }, [threadId, session])
  return !project ? (
    <></>
  ) : (
    <Animate>
      <Tabs.Root className='rounded-md' defaultValue='overview'>
        <Tabs.List className='relative z-0 flex gap-1 px-1 shadow-[inset_0_-1px] shadow-gray-200 mb-4'>
          {session?.user?.projects?.map((project: ProjectWithRelations) => (
            <Tabs.Tab
              key={project.id}
              className='flex h-8 items-center justify-center border-0 px-2 text-sm font-medium text-gray-600 outline-none select-none before:inset-x-0 before:inset-y-1 before:rounded-sm before:-outline-offset-1 before:outline-blue-800 hover:text-gray-900 focus-visible:relative focus-visible:before:absolute focus-visible:before:outline focus-visible:before:outline-2 data-[selected]:text-gray-900'
              value='overview'
            >
              {project.name ?? project.repoUrl?.split('/').pop()}
            </Tabs.Tab>
          ))}
          <Tabs.Indicator className='absolute top-1/2 left-0 z-[-1] h-6 w-[var(--active-tab-width)] -translate-y-1/2 translate-x-[var(--active-tab-left)] rounded-sm bg-gray-100 transition-all duration-200 ease-in-out' />
        </Tabs.List>
        {/* {session?.user?.projects?.map((project: ProjectWithRelations) => (
          <Tabs.Panel
            key={project.id}
            className='relative flex h-26 items-center justify-center -outline-offset-1 outline-blue-800 focus-visible:rounded-md focus-visible:outline focus-visible:outline-2'
            value='overview'
          >
            <Toolbar.Root className='gap-px h-10 rounded-md border border-gray-200 p-0.5 mr-2'>
              <Toolbar.Group
                className='flex gap-1'
                aria-label='Numerical format'
              >
                <Toolbar.Button
                  className='flex items-center justify-center rounded-sm px-[0.75rem] font-[inherit] text-sm font-medium text-gray-600 select-none hover:bg-gray-100 focus-visible:bg-none focus-visible:outline focus-visible:outline-2 focus-visible:-outline-offset-1 focus-visible:outline-blue-800 active:bg-gray-200 data-[pressed]:bg-gray-100 data-[pressed]:text-gray-900'
                  aria-label='Format as currency'
                >
                  {'<'}
                </Toolbar.Button>
                <Select.Root defaultValue='helvetica'>
                  <Toolbar.Button
                    render={<Select.Trigger />}
                    className='flex h-8 min-w-32 items-center justify-between rounded-sm px-[0.75rem] font-[inherit] text-sm font-medium text-gray-600 select-none hover:bg-gray-100 focus-visible:bg-none focus-visible:outline focus-visible:outline-2 focus-visible:-outline-offset-1 focus-visible:outline-blue-800 active:bg-gray-200 data-[pressed]:bg-gray-100 data-[pressed]:text-gray-900'
                  >
                    You asked:{' '}
                    <Select.Value
                      placeholder='Setup project'
                      className='ml-2'
                    />
                  </Toolbar.Button>
                  <Select.Portal>
                    <Select.Positioner className='outline-none' sideOffset={8}>
                      <Select.Popup className='group origin-[var(--transform-origin)] rounded-md bg-[canvas] py-1 text-gray-900 shadow-lg shadow-gray-200 outline outline-1 outline-gray-200 transition-[transform,scale,opacity] data-[ending-style]:scale-90 data-[ending-style]:scale-100 data-[ending-style]:opacity-0 data-[ending-style]:opacity-100 data-[ending-style]:transition-none data-[starting-style]:scale-90 data-[starting-style]:opacity-0 data-[side=none]:data-[starting-style]:scale-100 data-[side=none]:data-[starting-style]:opacity-100 data-[side=none]:data-[starting-style]:transition-none dark:shadow-none dark:-outline-offset-1 dark:outline-gray-300'>
                        {dedupedHumanMessages?.map((message, i) => (
                          <Select.Item
                            key={i}
                            className='grid min-w-[var(--anchor-width)] cursor-default grid-cols-[0.75rem_1fr] items-center gap-2 py-2 pr-4 pl-2.5 text-sm leading-4 outline-none select-none group-data-[side=none]:min-w-[calc(var(--anchor-width)+1rem)] group-data-[side=none]:pr-12 group-data-[side=none]:text-base group-data-[side=none]:leading-4 data-[highlighted]:relative data-[highlighted]:z-0 data-[highlighted]:text-gray-50 data-[highlighted]:before:absolute data-[highlighted]:before:inset-x-1 data-[highlighted]:before:inset-y-0 data-[highlighted]:before:z-[-1] data-[highlighted]:before:rounded-sm data-[highlighted]:before:bg-gray-900'
                            value='helvetica'
                          >
                            <Select.ItemIndicator className='col-start-1'>
                              <CheckIcon className='size-3' />
                            </Select.ItemIndicator>
                            <Select.ItemText className='col-start-2'>
                              {message?.kwargs?.content.slice(0, 20)}...
                            </Select.ItemText>
                          </Select.Item>
                        ))}
                      </Select.Popup>
                    </Select.Positioner>
                  </Select.Portal>
                </Select.Root>{' '}
                <Toolbar.Button
                  className='flex items-center justify-center rounded-sm px-[0.75rem] font-[inherit] text-sm font-medium text-gray-600 select-none hover:bg-gray-100 focus-visible:bg-none focus-visible:outline focus-visible:outline-2 focus-visible:-outline-offset-1 focus-visible:outline-blue-800 active:bg-gray-200 data-[pressed]:bg-gray-100 data-[pressed]:text-gray-900'
                  aria-label='Format as currency'
                >
                  {'>'}
                </Toolbar.Button>
              </Toolbar.Group>
            </Toolbar.Root>
            <Select.Root
              value={threadId}
              onValueChange={value => {
                const params = new URLSearchParams(query)
                params.set('threadId', value)
                window.history.pushState(null, '', `?${params.toString()}`)
              }}
            >
              <Select.Trigger className='flex h-10 min-w-36 items-center justify-between gap-3 rounded-md border border-gray-200 pr-3 pl-3.5 text-base text-gray-900 select-none hover:bg-gray-100 focus-visible:outline focus-visible:outline-2 focus-visible:-outline-offset-1 focus-visible:outline-blue-800 active:bg-gray-100 data-[popup-open]:bg-gray-100'>
                <Select.Value placeholder='Select thread' />
                <Select.Icon className='flex'>
                  <ChevronsUpDownIcon />
                </Select.Icon>
              </Select.Trigger>
              <Select.Portal>
                <Select.Positioner className='outline-none' sideOffset={8}>
                  <Select.ScrollUpArrow className="top-0 z-[1] flex h-4 w-full cursor-default items-center justify-center rounded-md bg-[canvas] text-center text-xs before:absolute before:top-[-100%] before:left-0 before:h-full before:w-full before:content-[''] data-[direction=down]:bottom-0 data-[direction=down]:before:bottom-[-100%]" />
                  <Select.Popup className='group [max-height:var(--available-height)] origin-[var(--transform-origin)] overflow-y-auto rounded-md bg-[canvas] py-1 text-gray-900 shadow-lg shadow-gray-200 outline outline-1 outline-gray-200 transition-[transform,scale,opacity] data-[ending-style]:scale-90 data-[ending-style]:scale-100 data-[ending-style]:opacity-0 data-[ending-style]:opacity-100 data-[ending-style]:transition-none data-[starting-style]:scale-90 data-[starting-style]:opacity-0 data-[side=none]:data-[starting-style]:scale-100 data-[side=none]:data-[starting-style]:opacity-100 data-[side=none]:data-[starting-style]:transition-none dark:shadow-none dark:-outline-offset-1 dark:outline-gray-300'>
                    {project.threads?.map(thread => (
                      <Select.Item
                        key={thread.id}
                        className='grid min-w-[var(--anchor-width)] cursor-default grid-cols-[0.75rem_1fr] items-center gap-2 py-2 pr-4 pl-2.5 text-sm leading-4 outline-none select-none group-data-[side=none]:min-w-[calc(var(--anchor-width)+1rem)] group-data-[side=none]:pr-12 group-data-[side=none]:text-base group-data-[side=none]:leading-4 data-[highlighted]:relative data-[highlighted]:z-0 data-[highlighted]:text-gray-50 data-[highlighted]:before:absolute data-[highlighted]:before:inset-x-1 data-[highlighted]:before:inset-y-0 data-[highlighted]:before:z-[-1] data-[highlighted]:before:rounded-sm data-[highlighted]:before:bg-gray-900'
                        value={thread.id}
                      >
                        <Select.ItemIndicator className='col-start-1'>
                          <CheckIcon className='size-3' />
                        </Select.ItemIndicator>
                        <Select.ItemText className='col-start-2'>
                          {thread.title ?? thread.id}
                        </Select.ItemText>
                      </Select.Item>
                    ))}
                  </Select.Popup>
                  <Select.ScrollDownArrow className="bottom-0 z-[1] flex h-4 w-full cursor-default items-center justify-center rounded-md bg-[canvas] text-center text-xs before:absolute before:top-[-100%] before:left-0 before:h-full before:w-full before:content-[''] data-[direction=down]:bottom-0 data-[direction=down]:before:bottom-[-100%]" />
                </Select.Positioner>
              </Select.Portal>
            </Select.Root>
          </Tabs.Panel>
        ))} */}
      </Tabs.Root>
    </Animate>
  )
}

export default Projects
